<!-- Left: menu toggle + brand / breadcrumb -->
<div class="compsych-hnav__left">
  @if (showMenuToggle) {
    <button
      type="button"
      class="compsych-hnav__icon-btn"
      [attr.aria-label]="sidebarOpen ? 'Close menu' : 'Open menu'"
      [attr.aria-expanded]="sidebarOpen"
      (click)="action.emit('menu-toggle')"
    >
      <span class="compsych-hnav__icon" [innerHTML]="menuIconSvg" aria-hidden="true"></span>
    </button>
  }

  @if (isSubPage) {
    <span class="compsych-hnav__symbol" aria-hidden="true">
      <svg viewBox="0 0 25.73 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.8653 14.1245C16.8469 14.1245 20.3525 16.2028 22.3536 19.3315H3.37704C5.31567 16.3005 8.6659 14.2552 12.4933 14.1304L12.8653 14.1245ZM12.8653 7.84521C18.6037 7.84521 23.2716 12.5137 23.2716 18.2515C23.2716 18.4109 23.267 18.5699 23.2599 18.728C21.0624 15.3064 17.223 13.0347 12.8643 13.0347C8.50575 13.0347 4.66828 15.3048 2.47079 18.7251C2.46367 18.5683 2.46005 18.4102 2.46005 18.2515C2.46005 12.5132 7.1278 7.84543 12.8653 7.84521ZM12.8653 1.56689C19.4758 1.56689 24.8543 6.94473 24.8546 13.5552C24.8546 14.8765 24.6389 16.1496 24.2423 17.3394C23.7763 11.4707 18.8512 6.83838 12.8653 6.83838C6.87959 6.83857 1.95592 11.4715 1.48935 17.3394C1.09275 16.1496 0.877045 14.8765 0.877045 13.5552C0.877289 6.94485 6.25504 1.56709 12.8653 1.56689Z" fill="currentColor"/>
      </svg>
    </span>
    <nav class="compsych-hnav__breadcrumb" aria-label="Breadcrumb">
      <ol role="list">
        @for (crumb of breadcrumbs; track crumb.id; let last = $last) {
          <li>
            <span class="compsych-hnav__sep" aria-hidden="true">/</span>
            @if (last) {
              <span class="compsych-hnav__crumb compsych-hnav__crumb--current" aria-current="page">{{ crumb.label }}</span>
            } @else {
              <button type="button" class="compsych-hnav__crumb" (click)="action.emit(crumb.id)">{{ crumb.label }}</button>
            }
          </li>
        }
      </ol>
    </nav>
  } @else {
    <button type="button" class="compsych-hnav__brand" [attr.aria-label]="brandLabelAria" (click)="action.emit('logo')">
      @if (clientLogoUrl) {
        <img [src]="clientLogoUrl" class="compsych-hnav__logo" [attr.aria-label]="brandLabelAria" alt="">
      } @else {
        <svg class="compsych-hnav__logo" role="img" [attr.aria-label]="brandLabelAria" viewBox="0 0 118 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.8653 14.1245C16.8469 14.1245 20.3525 16.2028 22.3536 19.3315H3.37704C5.31567 16.3005 8.6659 14.2552 12.4933 14.1304L12.8653 14.1245ZM12.8653 7.84521C18.6037 7.84521 23.2716 12.5137 23.2716 18.2515C23.2716 18.4109 23.267 18.5699 23.2599 18.728C21.0624 15.3064 17.223 13.0347 12.8643 13.0347C8.50575 13.0347 4.66828 15.3048 2.47079 18.7251C2.46367 18.5683 2.46005 18.4102 2.46005 18.2515C2.46005 12.5132 7.1278 7.84543 12.8653 7.84521ZM12.8653 1.56689C19.4758 1.56689 24.8543 6.94473 24.8546 13.5552C24.8546 14.8765 24.6389 16.1496 24.2423 17.3394C23.7763 11.4707 18.8512 6.83838 12.8653 6.83838C6.87959 6.83857 1.95592 11.4715 1.48935 17.3394C1.09275 16.1496 0.877045 14.8765 0.877045 13.5552C0.877289 6.94485 6.25504 1.56709 12.8653 1.56689Z" fill="currentColor"/>
          <path d="M100.224 10.1401C99.6034 10.1778 99.2832 10.4202 98.9648 11.1655L95.2646 20.0396C94.401 22.0893 93.2696 23.0217 92.0479 23.1187C90.1758 23.2669 89.8026 22.2909 90.001 21.8384C90.1891 21.4101 90.7857 21.432 91.376 21.688C92.9483 22.3923 94.1901 21.1819 94.7578 19.9478L95.0771 19.1646L91.7148 11.1675C91.3769 10.4225 91.0572 10.1795 90.457 10.1431V9.88135H94.4385V10.1431C93.5556 10.1807 93.1605 10.5339 93.4238 11.1489L95.8848 17.2085L98.4014 11.1694C98.6648 10.5356 98.3066 10.1804 97.4805 10.144V9.87939H100.224V10.1401ZM42.1875 6.48486C44.4823 6.48486 46.2325 7.53169 46.7402 9.23096L46.7695 9.32764C46.9127 9.82287 46.5881 10.3309 46.0771 10.4155C45.6244 10.4908 45.1893 10.2032 45.0869 9.75928V9.75439C44.6901 8.07409 43.4871 6.99187 41.9629 6.9917C39.5355 6.9917 37.8613 9.25128 37.8613 12.5366C37.8615 15.8216 39.8557 18.1185 42.6963 18.1187C44.6906 18.1187 46.1534 17.0358 46.7363 15.355L47.042 15.4116C46.4028 17.9504 44.5009 19.519 41.9619 19.519L41.9609 19.5181L41.9619 19.5171L41.6426 19.5093C38.3673 19.3473 36.0548 16.7007 36.0547 13.3003C36.0547 9.34151 38.4247 6.48504 42.1875 6.48486ZM52.25 9.60107C54.8819 9.60107 56.543 11.5448 56.543 14.3667C56.543 17.4128 54.7326 19.5063 52.082 19.5063C49.4316 19.5063 47.7891 17.5624 47.7891 14.7593C47.7891 11.7132 49.6182 9.60114 52.25 9.60107ZM103.946 9.6167C105.862 9.61671 107.065 10.8474 107.252 11.8726C107.256 11.8884 107.455 12.641 106.806 12.8394C106.402 12.9623 105.897 12.7605 105.769 12.2085C105.556 11.2968 104.979 10.1392 103.702 10.1392C102.124 10.1392 101.054 11.7431 101.054 13.8667C101.054 16.4016 102.35 18.1538 104.436 18.1538C105.544 18.1537 106.615 17.576 107.29 16.3833L107.516 16.439C107.027 18.3032 105.675 19.4956 103.759 19.4956V19.4976C101.166 19.4974 99.457 17.3907 99.457 14.6685C99.4572 11.9463 101.166 9.6167 103.946 9.6167ZM86.9658 9.60693C88.5252 9.60693 90.0049 10.2854 90.3486 11.4526C90.4274 11.7209 90.4283 12.2344 90.0801 12.4097C89.7292 12.5859 89.3006 12.3929 89.1406 12.0493C88.6399 10.9763 88.1187 10.1296 86.749 10.1294C85.6223 10.1294 84.9748 10.7634 84.9746 11.6772C84.9746 12.8172 86.1343 13.2135 87.3945 13.6431C88.8752 14.1476 90.4945 14.6992 90.5352 16.562C90.5733 18.2954 88.971 19.4887 86.96 19.4888L86.959 19.4878V19.4858C85.3417 19.4872 83.9282 19.0132 83.3555 17.9028C83.1887 17.5793 83.2679 17.1326 83.5967 16.9761C83.9951 16.7863 84.3966 17.1152 84.6123 17.5005C85.1159 18.4011 86.1587 18.9632 87.0879 18.9634C88.2717 18.9634 89.2381 18.2926 89.2383 17.2681C89.2201 15.9311 87.9619 15.5017 86.6465 15.0532C85.2106 14.5636 83.7073 14.0505 83.6777 12.3091C83.6595 10.7051 84.9748 9.60708 86.9658 9.60693ZM110.52 11.6938C111.509 10.3857 112.498 9.60107 113.805 9.60107C115.447 9.60115 116.399 10.6471 116.399 12.4595V17.8608C116.399 18.6829 116.959 18.8511 117.631 18.9819V19.2437H113.618V18.9819C114.29 18.8511 114.85 18.6828 114.85 17.8608V12.5532C114.85 11.3947 114.197 10.6842 113.133 10.6841C112.218 10.6841 111.453 11.0956 110.52 12.1606V17.8608C110.52 18.6829 111.079 18.8511 111.751 18.9819V19.2437H107.72V18.9819C108.41 18.8511 108.97 18.6829 108.97 17.8608V8.04932C108.97 7.41406 108.671 7.11501 107.999 7.07764H107.552V6.81592L110.258 6.05029H110.52V11.6938ZM78.2471 6.76709L78.249 6.76807C81.1606 6.76807 83.1533 7.86945 83.1533 10.2554C83.1531 12.641 81.1615 13.7222 78.249 13.7222H77.0264V13.4331C80.258 13.4331 81.3154 11.9881 81.3105 10.2554C81.3055 8.52254 80.1832 7.29064 78.043 7.29053H76.3525L76.3506 17.562C76.3506 18.6802 76.8959 18.8865 78.0215 18.9604V19.2212H68.7891V18.9604C69.4654 18.8304 70.0283 18.6616 70.0283 17.8413V12.5474C70.0282 11.391 69.3706 10.6831 68.2998 10.6831C67.3412 10.6831 66.5705 11.1121 65.6133 12.231V17.8423C65.6133 18.6635 66.177 18.8314 66.8535 18.9614V19.2231H62.8145V18.9614C63.491 18.8314 64.0547 18.6627 64.0547 17.8423V12.5483C64.0545 11.3921 63.3963 10.6841 62.3271 10.6841C61.4441 10.6841 60.711 11.0579 59.8291 12.0083V17.8442C59.8293 18.6649 60.3921 18.8324 61.0684 18.9624V19.2241H57.0098V18.9624C57.7046 18.8316 58.2684 18.6643 58.2686 17.8442V11.5991C58.2686 10.9653 57.9682 10.6659 57.292 10.6099H56.8418V10.3481L59.5654 9.5835H59.8291V11.522C60.7869 10.31 61.7449 9.60208 63.0029 9.60205C64.4503 9.60205 65.3706 10.4033 65.5762 11.8198C66.6086 10.4401 67.6239 9.60208 68.9766 9.60205C70.629 9.60205 71.5879 10.6464 71.5879 12.4546V17.8423L71.5859 17.8403C71.5859 18.3871 71.8364 18.6442 72.2041 18.7935C72.5694 18.9413 73.0559 18.9637 73.4463 18.9058C74.2358 18.788 74.6386 18.4873 74.6387 17.561V8.40674C74.6386 7.32569 74.094 7.10187 72.9482 7.02686V6.76514H78.2461L78.2471 6.76709ZM51.9512 10.1245C50.4208 10.1247 49.4503 11.7317 49.4502 14.0112C49.4502 16.1043 50.2529 18.9829 52.3994 18.9829C53.9487 18.9829 54.9004 17.3567 54.9004 15.0581C54.9004 13.0024 54.0791 10.1245 51.9512 10.1245Z" fill="currentColor"/>
        </svg>
      }
      @if (brandLabel) {
        <span class="compsych-hnav__brand-label" [attr.aria-label]="brandLabelAria" [style.color]="brandLabelColor">{{ brandLabel }}</span>
      }
    </button>
  }
</div>

<!-- Right: actions -->
<div class="compsych-hnav__actions">
  @if (isLoggedOut) {
    @if (showLanguage) {
      <button type="button" class="compsych-hnav__icon-btn compsych-hnav__overflow-core" aria-label="Language" (click)="action.emit('language')">
        <span class="compsych-hnav__icon" [innerHTML]="globeIconSvg" aria-hidden="true"></span>
      </button>
    }
    @if (showHelp) {
      <button type="button" class="compsych-hnav__icon-btn compsych-hnav__overflow-core" aria-label="Help" (click)="action.emit('help')">
        <span class="compsych-hnav__icon" [innerHTML]="helpIconSvg" aria-hidden="true"></span>
      </button>
    }
    @if (actionButtons.length) {
      <div class="compsych-hnav__action-btns">
        @for (btn of actionButtons; track btn.id) {
          <compsych-button
            [variant]="btn.variant ?? 'filled'"
            size="medium"
            [label]="btn.label"
            [leadingIcon]="btn.leadingIcon"
            [trailingIcon]="btn.trailingIcon"
            [disabled]="!!btn.disabled"
            [loading]="!!btn.loading"
            (click)="action.emit(btn.id)"
          ></compsych-button>
        }
      </div>
    }
  } @else {
    @if (showSearch) {
      <button type="button" class="compsych-hnav__icon-btn compsych-hnav__overflow-core" aria-label="Search" (click)="action.emit('search')">
        <span class="compsych-hnav__icon" [innerHTML]="searchIconSvg" aria-hidden="true"></span>
      </button>
    }
    @if (showCalendarChecked) {
      <button type="button" class="compsych-hnav__icon-btn compsych-hnav__overflow-core" aria-label="Calendar" (click)="action.emit('calendar-checked')">
        <span class="compsych-hnav__icon" [innerHTML]="calendarCheckedIconSvg" aria-hidden="true"></span>
      </button>
    }
    @if (showNotifications) {
      <button
        type="button"
        class="compsych-hnav__icon-btn compsych-hnav__overflow-aux"
        [attr.aria-label]="notificationAriaLabel"
        (click)="action.emit('notifications')"
      >
        <span class="compsych-hnav__icon" [innerHTML]="bellIconSvg" aria-hidden="true"></span>
        @if (notificationCount > 0) {
          <span class="compsych-hnav__badge" aria-hidden="true">{{ badgeText }}</span>
        }
      </button>
    }
    @if (showDocuments) {
      <button
        type="button"
        class="compsych-hnav__icon-btn compsych-hnav__overflow-aux"
        aria-label="Documents"
        (click)="action.emit('documents')"
      >
        <span class="compsych-hnav__icon" [innerHTML]="fileTextIconSvg" aria-hidden="true"></span>
      </button>
    }
    @if (showLanguage) {
      <button type="button" class="compsych-hnav__icon-btn compsych-hnav__overflow-core" aria-label="Language" (click)="action.emit('language')">
        <span class="compsych-hnav__icon" [innerHTML]="globeIconSvg" aria-hidden="true"></span>
      </button>
    }
    @if (actionButtons.length) {
      <div class="compsych-hnav__action-btns">
        @for (btn of actionButtons; track btn.id) {
          <compsych-button
            [variant]="btn.variant ?? 'filled'"
            size="medium"
            [label]="btn.label"
            [leadingIcon]="btn.leadingIcon"
            [trailingIcon]="btn.trailingIcon"
            [disabled]="!!btn.disabled"
            [loading]="!!btn.loading"
            (click)="action.emit(btn.id)"
          ></compsych-button>
        }
      </div>
    }
    @if (showAvatar) {
      <button
        type="button"
        class="compsych-hnav__avatar compsych-hnav__overflow-core"
        [attr.aria-label]="avatarInitials ? 'Account: ' + avatarInitials : 'Account'"
        (click)="action.emit('avatar')"
      >
        @if (avatarInitials) {
          {{ avatarInitials }}
        } @else {
          <span class="compsych-hnav__icon" [innerHTML]="userIconSvg" aria-hidden="true"></span>
        }
      </button>
    }
    @if (showLogout) {
      <button type="button" class="compsych-hnav__icon-btn" aria-label="Logout" (click)="action.emit('logout')">
        <span class="compsych-hnav__icon" [innerHTML]="logOutIconSvg" aria-hidden="true"></span>
      </button>
    }
  }
</div>
